import { render, staticRenderFns } from "./CmsSafeEducate.vue?vue&type=template&id=a02a8052&scoped=true&"
import script from "./CmsSafeEducate.vue?vue&type=script&lang=js&"
export * from "./CmsSafeEducate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02a8052",
  null
  
)

export default component.exports